import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetManagementApiService from './AssetManagementApiService'
import { GET_VEHICLE_CAPACITY } from '../../Store/AssetManagement/VehicleCapacity/VehicleCapacityType'
import { setVehicleCapacity } from 'Store/AssetManagement/VehicleCapacity/VehicleCapacityAction';
import { apiMethod, apiType, API_URL } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getVehicleCapacity(req: any): any {

    let payloadData : IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `assets/dropdown/vehicle/capacity/${req.val}`,
        payload : null
    }

    try {
        yield put(globalLoaderText("Fetching Vehicle Capacity...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response?.length > 0) {
        const defaultVehicleCapacityOption = {
                text: "Select Vehicle Capacity",
                value: null
          };
          response.unshift(defaultVehicleCapacityOption);
        }
        yield put(setVehicleCapacity(response))

        yield put(globalLoaderText(""));

    } catch (error) {
        yield put(setVehicleCapacity([]))
        yield put(globalLoaderText(""));
    }
}

function* watchGetVehicleCapacity() {
    yield takeEvery(GET_VEHICLE_CAPACITY, getVehicleCapacity)
}

export default function* combinedSaga() {
    yield all([
        watchGetVehicleCapacity()
    ])
  }
